import { render } from "./App.vue?vue&type=template&id=ed480916&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=ed480916&lang=scss"
import "./App.vue?vue&type=style&index=1&id=ed480916&lang=css"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\program-list-acom26\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__